import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

// 支付系统一级
const userRouter: RouteConfig = {
  path: '/payment',
  component: Layout,
  redirect: '/payment/payment-manage',
  meta: {
    title: '支付',
    icon: 'menu-pay',
    alwaysShowMenu: true
  },
  children: [
    {
      name: 'payment',
      path: 'payment-manage',
      component: () => import('@/views/payment/payment-manage/index.vue'),
      redirect: '/payment/payment-manage/payment-board',
      meta: {
        title: '支付管理'
      },
      children: [
        {
          name: 'paymentManage',
          path: 'payment-board',
          component: () => import('@/views/payment/payment-manage/payment-board.vue'),
          meta: {
            title: '看板'
          }
        },
        // {
        //   name: 'passagewayConfig',
        //   path: 'passageway-config',
        //   component: () => import('@/views/payment/payment-manage/passageway-config.vue'),
        //   meta: {
        //     title: '通道配置'
        //   }
        // },
        {
          name: 'statementQuery',
          path: 'statement-query',
          component: () => import('@/views/payment/payment-manage/statement-query.vue'),
          meta: {
            title: '流水查询'
          }
        },
        {
          name: 'paymentAccount',
          path: 'payment-account',
          component: () => import('@/views/payment/payment-manage/payment-account.vue'),
          meta: {
            title: '支付账号'
          }
        },
        {
          name: 'accessModule',
          path: 'access-module',
          component: () => import('@/views/payment/payment-manage/access-module.vue'),
          meta: {
            title: '通道配置'
          }
        }
      ]
    }
  ]
}

export default userRouter
